// The memory as the hive sees it: blurred and drifting, sharpening as clarity rises 0 -> 1.
export const ClarityField = ({ specimen, clarity }) => {
  const words = (specimen.memory?.script || "").split(/\s+/).slice(0, 28).join(" ");
  const blur = Math.round((1 - clarity) * 14);
  const pct = Math.round(clarity * 100);
  return (
    <div data-testid="clarity-field" data-clarity={pct} className="relative overflow-hidden border border-cyan-400/20 bg-slate-950/70 p-6">
      <div className="pointer-events-none absolute inset-0 opacity-30 mix-blend-screen [background:repeating-linear-gradient(0deg,transparent_0_2px,rgba(0,255,157,0.08)_2px_3px)]" />
      <p className="lab-label !text-cyan-300">Memory signal · {pct}%</p>
      <div className="mt-3 h-1.5 w-full bg-slate-800">
        <div data-testid="clarity-bar" className="h-full bg-cyan-300 transition-[width] duration-700" style={{ width: `${pct}%` }} />
      </div>
      <h3
        data-testid="clarity-title"
        className="mt-5 font-display text-3xl uppercase tracking-wide text-slate-100 transition-[filter,opacity] duration-700"
        style={{ filter: `blur(${blur * 0.6}px)`, opacity: 0.35 + clarity * 0.65 }}
      >
        {specimen.memory?.title || specimen.name}
      </h3>
      <p
        data-testid="clarity-script"
        className="mt-3 max-w-2xl text-base leading-relaxed text-slate-300 transition-[filter,opacity] duration-700"
        style={{ filter: `blur(${blur}px)`, opacity: 0.25 + clarity * 0.6, transform: `translateX(${(1 - clarity) * 6}px)` }}
      >
        {words}…
      </p>
    </div>
  );
};
